import TimeSheetTabContent from './TimeSheetTabContent';

const ToBeCheckedContent = () => (
  <TimeSheetTabContent status="1" emptyStateType="time_sheet_to_be_checked" />
);

export default ToBeCheckedContent;
